import React from 'react'
import { DataGrid, type GridColDef } from '@mui/x-data-grid'
import { useGetProfileUpdatesQuery } from '../../../api-services/asset-holdings/assetHolderApi'
import LoadingComponent from '../../components/ui-widgets/LoadingComponent'
import ErrorComponent from '../../components/ui-widgets/ErrorComponent'
import { RtkQueryHelper } from '../../../api-services/shared/RtkQueryHelper'
import { type EditAssetHolderProps } from './EditAssetHolderForm'

const ProfileUpdatesComponent: React.FC<EditAssetHolderProps> = ({ assetHolder }: EditAssetHolderProps) => {
  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', editable: false, flex: 5 },
    { field: 'assetHolderName', headerName: 'Asset Holder Name', flex: 15 },
    { field: 'updatedBy', headerName: 'Updated By', flex: 15 },
    { field: 'updatedFromIp', headerName: 'Updated From IP', flex: 10 },
    { field: 'kycReset', headerName: 'KYC Reset', type: 'boolean', flex: 10 },
    { field: 'dateUpdatedFormatted', headerName: 'Date Updated', flex: 15 },
    {
      field: 'valuesAfterUpdate',
      headerName: 'After Update',
      flex: 45,
      renderCell: params => (
        <pre>{JSON.stringify(params.row.valuesAfterUpdate, null, 2)}</pre>
      )
    },
    {
      field: 'valuesBeforeUpdate',
      headerName: 'Before Update',
      flex: 45,
      renderCell: params => (
        <pre>{JSON.stringify(params.row.valuesBeforeUpdate, null, 2)}</pre>
      )
    }
  ]

  const getAssetHolderProfileUpdates = useGetProfileUpdatesQuery(assetHolder.assetHolderId)

  return (
    <>
      <h3>Profile Updates History</h3>

      {getAssetHolderProfileUpdates.isLoading && <LoadingComponent/>}
      {getAssetHolderProfileUpdates.isError &&
        <ErrorComponent message={RtkQueryHelper.mapResponseError(getAssetHolderProfileUpdates.error)}/>}
      {getAssetHolderProfileUpdates.isSuccess &&
        <>
          <DataGrid
            getRowId={(row) => row.id}
            rows={getAssetHolderProfileUpdates.data}
            columns={columns}
            autoHeight={true}
            getRowHeight={() => 'auto'}
            getEstimatedRowHeight={() => 150}
            pagination
            pageSize={20}
            rowsPerPageOptions={[20]}
            sx={{
              '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
                py: 1
              },
              '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
                py: '15px'
              },
              '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
                py: '22px'
              }
            }}
          />
        </>
      }
    </>
  )
}

export default ProfileUpdatesComponent
